export function array(arr) {
  return Array.isArray(arr) ? arr : [];
}
